import { useTranslation } from 'react-i18next';
{
  /* <GlobalOutlined /> */
}
import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const { Option } = Select;

export default function LanguageSwitcher({ className }) {
  const { i18n } = useTranslation();
  const langSet = [
    { lebel: '한국어', value: 'ko' },
    { lebel: 'English', value: 'en' },
    { lebel: 'Chinese', value: 'zh' },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Select
      key={`lang-${i18n.language}`}
      className={className}
      placeholder="선택"
      onChange={changeLanguage}
      defaultValue={i18n.language}
      suffixIcon={<GlobalOutlined className="ms-2" />}
    >
      {langSet.map((lang, _lang_idx) => (
        <Option key={`countries-${_lang_idx}-${lang.value}`} value={lang.value}>
          {lang.label}
        </Option>
      ))}
    </Select>
  );
}
